var $914a51a8a594d5be$exports = {};
$914a51a8a594d5be$exports = {
    "longPressMessage": `Langt trykk eller trykk Alt + PilNed for \xe5 \xe5pne menyen`
};


export {$914a51a8a594d5be$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
